@import '../../../globals/main.scss';
@import './pn-product-card-common.scss';

pn-product-card-price {
  margin-top: 1rem;
  white-space: nowrap;
  text-align: center;

  display: flex;
  flex-direction: column;

  span:last-child {
    display: inline-block;
    margin-left: 0.2em;
  }
  & + pn-product-card-price {
    margin-right: 0;
  }

  pn-icon {
    display: inline-block;
    align-self: center;
  }

  .price {
    font-size: 2.5em;
    font-weight: bold;
    order: 1;
  }
  pn-button {
    min-width: 12.8em;
    font-size: 1.25;
    order: 2;

    @media screen and (min-width: $productcard-media-tablet) {
      order: 3;
      margin-bottom: 1.6rem;
    }
  }

  p {
    font-weight: lighter;
    font-size: 0.875em;
    align-self: center;
    margin-top: 0.8rem;
    order: 3;
    @media screen and (min-width: $productcard-media-tablet) {
      order: 2;
    }
  }
}
